import React, { useState, useEffect } from "react";
import styles from "../userManagement.module.css";
import UserForm from "./UserForm";


export default function AuthorUserForm({ authorUserData, handleAuthorUserDataChange, handleAddListItem, handleRemoveListItem, handleListItemChange, imagePreview, handleImageChange, isEditMode }) {
  const genders = ["남", "여", "기타"];
  const degreeOptions = ["UNKNOWN", "고등학교", "학사", "석사", "박사"];
  const ratingOptions = ["UNKNOWN", "A", "B", "C", "D", "E", "F"];
  const snsOptions = ["FACEBOOK", "X", "YOUTUBE", "NAVER", "INSTAGRAM"];

  const koreanBanks = [
    "국민은행",      // KB Kookmin Bank
    "신한은행",      // Shinhan Bank
    "우리은행",      // Woori Bank
    "하나은행",      // Hana Bank
    "농협은행",      // NongHyup (NH Bank)
    "기업은행",      // IBK Industrial Bank of Korea
    "카카오뱅크",    // KakaoBank
    "케이뱅크",      // K Bank
    "부산은행",      // Busan Bank
    "대구은행",      // Daegu Bank
    "경남은행",      // Kyongnam Bank
    "광주은행",      // Kwangju Bank
    "전북은행",      // Jeonbuk Bank
    "수협은행",      // Suhyup Bank (Korea Federation of Fisheries Cooperatives)
    "제주은행",      // Jeju Bank
    "우체국",        // Korea Post (Post Office Banking)
    "SC제일은행",    // Standard Chartered Korea
    "씨티은행"       // Citibank Korea
  ];

  const [calculatedAge, setCalculatedAge] = useState("");

  const calculateAge = (firstHalf, secondHalf) => {
    if (!firstHalf || !secondHalf || firstHalf.length !== 6 || secondHalf.length !== 7) {
      setCalculatedAge("유효하지 않은 주민등록번호");
      return;
    }

    // 생년월일 추출 (앞 6자리)
    const genderCode = secondHalf.charAt(0); // 뒷자리 첫 번째 숫자
    let birthYearPrefix;

    if (genderCode == "1" || genderCode == "2") {
      birthYearPrefix = 1900;
    } else if (genderCode == "3" || genderCode == "4") {
      birthYearPrefix = 2000;
    } else if (genderCode == "5" || genderCode == "6") {
      birthYearPrefix = 1900;
    } else if (genderCode == "7" || genderCode == "8") {
      birthYearPrefix = 2000;
    } else {
      setCalculatedAge("유효하지 않은 주민등록번호");
      return;
    }

    const year = birthYearPrefix + parseInt(firstHalf.slice(0, 2), 10);
    const month = parseInt(firstHalf.slice(2, 4), 10);
    const day = parseInt(firstHalf.slice(4, 6), 10);

    if (month < 1 || month > 12 || day < 1 || day > 31) {
      setCalculatedAge("유효하지 않은 생년월일");
      return;
    }

    const today = new Date();
    const currentYear = today.getFullYear();

    const koreanAge = currentYear - year + 1

    setCalculatedAge(koreanAge); // 계산된 나이 설정
  };

  useEffect(() => {
    if (!authorUserData?.idFirstHalf || !authorUserData.idSecondHalf) return;

    if (authorUserData.idFirstHalf.length === 6 && authorUserData.idSecondHalf.length === 7) {
      calculateAge(authorUserData.idFirstHalf, authorUserData.idSecondHalf);
    } else {
      setCalculatedAge("");
    }
  }, [authorUserData]);

  return (
    <div className={styles.formGrid}>
      <div className={styles.formColumn}>

        <UserForm
          userData={authorUserData}
          handleUserDataChange={handleAuthorUserDataChange}
          imagePreview={imagePreview}
          handleImageChange={handleImageChange}
          isEditMode={isEditMode}
        />

        <div className={styles.detailsSection}>
          <div className={styles.formRow}>
            <label>주민등록번호</label>
            <div className={styles.formInputGroup}>
              <input
                type="text"
                maxLength="6"
                name="idFirstHalf"
                value={authorUserData.idFirstHalf}
                onChange={handleAuthorUserDataChange}
              />
              <span>-</span>
              <input
                type="text"
                maxLength="7"
                name="idSecondHalf"
                value={authorUserData.idSecondHalf}
                onChange={handleAuthorUserDataChange}
              />
            </div>
          </div>
          <div className={styles.formRow}>
            <label>나이</label>
            <div className={styles.formInputGroup}>
              <input
                type="text"
                value={calculatedAge}
                readOnly
                placeholder="(자동계산)"
              />
              <label>성별</label>
              <select
                name="gender"
                value={authorUserData.gender}
                onChange={handleAuthorUserDataChange}
              >
                <option value="" disabled>
                  -
                </option>
                {genders.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className={styles.formRow}>
            <label>주소</label>
            <input
              type="text"
              name="address"
              value={authorUserData.address || ""}
              onChange={handleAuthorUserDataChange}
            />
          </div>
          <div className={styles.formRow}>
            <label className={styles.deliveryLabel}>
              배송지
              <input
                type="checkbox"
                name="useSameAddress"
                checked={authorUserData.useSameAddress}
                onChange={handleAuthorUserDataChange}
              />
              [동일]
            </label>
            <input
              type="text"
              name="deliveryAddress"
              value={authorUserData.deliveryAddress || ""}
              onChange={handleAuthorUserDataChange}
            />
          </div>
          <div className={styles.formRow}>
            <label>Fax</label>
            <input
              type="text"
              name="fax"
              value={authorUserData.fax || ""}
              onChange={handleAuthorUserDataChange}
            />
          </div>
        </div>
        <div className={styles.detailsSection}>
          <div className={styles.formRow}>
            <label>계좌번호</label>
            <div className={styles.formInputGroup}>
              <select
                name="bankName"
                value={authorUserData.bankName}
                onChange={handleAuthorUserDataChange}
              >
                <option value="" disabled>
                  -
                </option>
                {koreanBanks.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
              <input
                type="text"
                name="bankAccountNumber"
                value={authorUserData.bankAccountNumber || ""}
                onChange={handleAuthorUserDataChange}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.formColumn}>
        <div className={styles.detailsSection}>

          <div className={styles.formRow}>
            <label>필명</label>
            <input
              type="text"
              name="penName"
              value={authorUserData.penName || ""}
              onChange={handleAuthorUserDataChange}
            />
          </div>

          <div className={styles.formRow}>
            <label>장르</label>
            <div className={styles.formInputGroup}>
              <input
                type="text"
                name="genre"
                value={authorUserData.genre}
                onChange={handleAuthorUserDataChange}
              />
              <label>하위장르</label>
              <input
              type="text"
                name="subgenre"
                value={authorUserData.subgenre}
                onChange={handleAuthorUserDataChange}
              />
            </div>
          </div>

          <div className={styles.formRow}>
            <label>출신학교</label>
            <input
              type="text"
              name="education"
              value={authorUserData.education || ""}
              onChange={handleAuthorUserDataChange}
            />
          </div>

          <div className={styles.formRow}>
            <label>학위</label>
            <div className={styles.formInputGroup}>
              <select
                name="degree"
                value={authorUserData.degree}
                onChange={handleAuthorUserDataChange}
              >
                {degreeOptions.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
              <label>전공</label>
              <input
                type="text"
                name="major"
                value={authorUserData.major || ""}
                onChange={handleAuthorUserDataChange}
              />
            </div>
          </div>
          <div className={styles.formRow}>
            <label>소속</label>
            <input
              type="text"
              name="organization"
              value={authorUserData.organization || ""}
              onChange={handleAuthorUserDataChange}
            />
          </div>
          <div className={styles.formRow}>
            <label>
              경력{" "}
              <button
                type="button"
                className={styles.plusBtn}
                onClick={() =>
                  handleAddListItem("career", { title: "", description: "" })
                }
              >
                +
              </button>
            </label>
          </div>
          {authorUserData.career.map((item, index) => (
            <div key={index} className={styles.formRowDynamic}>
              <input
                type="text"
                placeholder="Career Title"
                value={item.title}
                onChange={(e) =>
                  handleListItemChange("career", index, "title", e.target.value)
                }
              />
              <input
                type="text"
                placeholder="Career Description"
                value={item.description}
                onChange={(e) =>
                  handleListItemChange(
                    "career",
                    index,
                    "description",
                    e.target.value
                  )
                }
              />
              <button
                type="button"
                className={styles.formDeleteBtn}
                onClick={() => handleRemoveListItem("career", index)}
              />
            </div>
          ))}

          <div className={styles.formRow}>
            <label>
              대표저서{" "}
              <button
                type="button"
                className={styles.plusBtn}
                onClick={() => handleAddListItem("notableWork", { title: "" })}
              >
                +
              </button>
            </label>
          </div>
          {authorUserData.notableWork.map((item, index) => (
            <div key={index} className={styles.formRowDynamic}>
              <input
                type="text"
                placeholder="Book Title"
                value={item.title}
                onChange={(e) =>
                  handleListItemChange(
                    "notableWork",
                    index,
                    "title",
                    e.target.value
                  )
                }
              />
              <button
                type="button"
                className={styles.formDeleteBtn}
                onClick={() => handleRemoveListItem("notableWork", index)}
              />
            </div>
          ))}

          <div className={styles.formRow}>
            <label>
              블로그/SNS{" "}
              <button
                type="button"
                className={styles.plusBtn}
                onClick={() => handleAddListItem("sns", { title: "", url: "" })}
              >
                +
              </button>
            </label>
          </div>
          {authorUserData.sns.map((item, index) => (
            <div key={index} className={styles.formRowDynamic}>
              <select
                type="text"
                value={item.title}
                onChange={(e) =>
                  handleListItemChange("sns", index, "title", e.target.value)
                }
                required
              >
                <option value="" disabled>
                  -
                </option>
                {snsOptions.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
              <input
                type="url"
                placeholder="https://..."
                value={item.url}
                onChange={(e) =>
                  handleListItemChange("sns", index, "url", e.target.value)
                }
              />
              <button
                type="button"
                className={styles.formDeleteBtn}
                onClick={() => handleRemoveListItem("sns", index)}
              />
            </div>
          ))}

          <div className={styles.formRow}>
            <label>등급</label>
            <select
              name="rating"
              value={authorUserData.rating}
              onChange={handleAuthorUserDataChange}
            >
              {ratingOptions.map((o) => (
                <option key={o} value={o}>
                  {o}
                </option>
              ))}
            </select>
          </div>
        </div>
        {/* <div className={styles.serviceSection}>
          <div className={styles.formRow}>
            <label>서비스 종류</label>
            <span>자비 출판 대행</span>
          </div>
          <div className={styles.formRow}>
            <label>서비스 기간</label>
            <span>2025.1.1 ~ 2025.12.30</span>
          </div>
          <div className={styles.serviceButtons}>
            <button type="button">견적서</button>
            <button type="button">계약서</button>
          </div>
        </div> */}
      </div>
    </div>
  );
};